
define(function (require) {
  var modalWindow = require("site/mobile/modal-window");
  var language = require("common/util/language");

  /**
   * Change the checkout page w/o any transition and by passing parameters.
   *
   * @param {String}  page      page
   * @param {String}  params    params
   * @param {Object}  options   options
   * > Boolean allowTransition
   * @returns {void}
   */
  return function changeCheckoutPage (page, params) {
    // redirect to Checkout UI
    var langPath = language.getLanguagePath(window.location.pathname);
    if (page === "checkout-page") {
      window.location.href = langPath + "/secure-checkout?" + params;
      return;
    }

    var pageId = "#" + page;
    var uri = pageId;

    if (params) {
      uri = `${uri}?${params}`;
    }

    window.location.hash = uri;
    modalWindow.hide();
  };
});
